// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__34PVf","col":"Table_col__1js_B","fulfillmentStatus":"Table_fulfillmentStatus__1bXM4","emailCol":"Table_emailCol__Iwkk1"};